module.exports = __webpack_public_path__ + "static/img/battery_level_01.343ca44.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_2020/battery_level_01.gif
// module id = X8dw
// module chunks = 1